import pb from "../../../lib/pb";


const API_URL =
    "https://api.myfavv.live";


async function request(
    path,
    options = {}
) {

    const isFormData =
        options.body instanceof FormData;


    const headers = {

        Authorization:
            `Bearer ${pb.authStore.token}`,

        ...(options.headers || {})

    };


    if (!isFormData) {

        headers[
            "Content-Type"
        ] = "application/json";

    }


    const response =
        await fetch(
            `${API_URL}${path}`,
            {
                ...options,
                headers
            }
        );


    let data = null;


    try {

        data =
            await response.json();

    } catch {

        data = null;

    }


    if (!response.ok) {

        throw new Error(
            data?.error ||
            data?.message ||
            "Delivery partner request failed."
        );

    }


    return data;

}


export async function submitPartnerOnboarding(
    form
) {

    const body =
        new FormData();


    body.append(
        "fullName",
        form.fullName || ""
    );


    body.append(
        "phone",
        form.phone || ""
    );


    body.append(
        "dateOfBirth",
        form.dateOfBirth || ""
    );


    body.append(
        "address",
        form.address || ""
    );


    body.append(
        "area",
        form.area || ""
    );


    body.append(
        "city",
        form.city || ""
    );


    body.append(
        "state",
        form.state || ""
    );


    body.append(
        "deliveryMode",
        form.deliveryMode || ""
    );


    body.append(
        "vehicleType",
        form.vehicleType || ""
    );


    body.append(
        "vehicleNumber",
        form.vehicleNumber || ""
    );


    body.append(
        "emergencyName",
        form.emergencyName || ""
    );


    body.append(
        "emergencyPhone",
        form.emergencyPhone || ""
    );


    body.append(
        "emergencyRelation",
        form.emergencyRelation || ""
    );


    if (
        form.identityDocument
    ) {

        body.append(
            "identityDocument",
            form.identityDocument
        );

    }


    if (
        form.drivingLicense
    ) {

        body.append(
            "drivingLicense",
            form.drivingLicense
        );

    }


    if (
        form.vehicleRc
    ) {

        body.append(
            "vehicleRc",
            form.vehicleRc
        );

    }


    if (
        form.selfie
    ) {

        body.append(
            "selfie",
            form.selfie
        );

    }


    return request(
        "/delivery-partners/onboarding",
        {
            method: "POST",
            body
        }
    );

}


export async function getPartnerProfile() {

    return request(
        "/fulfillment/partner/me"
    );

}


export async function updatePartnerStatus(
    status,
    acceptingOrders
) {

    return request(
        "/delivery-partners/status",
        {
            method: "POST",

            body:
                JSON.stringify({
                    status,
                    acceptingOrders
                })
        }
    );

}


export async function updatePartnerLocation(
    lat,
    lng
) {

    return request(
        "/delivery-partners/location",
        {
            method: "POST",

            body:
                JSON.stringify({
                    lat,
                    lng
                })
        }
    );

}

